module.exports = __webpack_public_path__ + "media/images/recipes/runderlenderollade-b9e51ae4128b3d3b0f12de9c6092f73a.pdf";